// Local Storage Keys
const LS_MEASUREMENTS_DIARY_TYPE = "Measurements_DiaryTypePerPatient";
const LS_MEASUREMENTS_DATE_RANGE = "Measurements_DateRangePerPatient";
const LS_MENU_MINIFIED = "Menu_Minified";
const LS_NEWS_SEEN = "News_Messages_Seen";
const LS_AUTO_LOGOUT_DISABLED = "AutoLogout_Disabled";
const LS_AUTO_LOGOUT_INTERVAL = "AutoLogout_Interval";
const LS_TRUST_DEVICE_UUID = "SaniQTrustDeviceUUID";
const LS_REMEMBER_TOKEN = "RememberToken";
const LS_VIDEO_CLIENT_ID = "SaniQVideoClient";
const LS_SENSOR_DEVICES = "Sensor_Devices";
// The AuthHeaders are stored in session storage
const SS_AUTH_HEADERS = "AuthHeaders";

export {
  LS_MEASUREMENTS_DIARY_TYPE,
  LS_MEASUREMENTS_DATE_RANGE,
  LS_MENU_MINIFIED,
  LS_NEWS_SEEN,
  LS_AUTO_LOGOUT_DISABLED,
  LS_AUTO_LOGOUT_INTERVAL,
  LS_TRUST_DEVICE_UUID,
  LS_REMEMBER_TOKEN,
  LS_VIDEO_CLIENT_ID,
  LS_SENSOR_DEVICES,
  SS_AUTH_HEADERS
};
